import React, { useEffect, useMemo } from "react";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, InputNumber, Radio, Row, Slider } from "antd";
import { EntityType, PriceAdjustType, PriceAdjustmentDirection } from "@/utils/enum";

const PriceAdjustmentControls = ({
  priceType,
  handleChangePriceType,
  priceAdjustmentType,
  handleChangePriceAdjustmentType,
  priceAdjustmentDirection,
  handleChangePriceAdjustmentDirection,
  priceAdjustmentAmount,
  setPriceAdjustmentAmount,
  priceSliderMarks,
  handleClickReset,
}) => {
  const maxAdjustmentAmount = useMemo(
    () => (priceAdjustmentType < PriceAdjustType.ByPercentage ? 1000 : 100),
    [priceAdjustmentType],
  );

  useEffect(() => {
    if (priceAdjustmentAmount > maxAdjustmentAmount && priceAdjustmentType === PriceAdjustType.ByPercentage) {
      setPriceAdjustmentAmount(maxAdjustmentAmount);
    }

    if (!priceAdjustmentAmount || priceAdjustmentAmount < 0) {
      setPriceAdjustmentAmount(0);
    }
  }, [priceAdjustmentAmount, maxAdjustmentAmount, setPriceAdjustmentAmount, priceAdjustmentType]);

  return (
    <>
      <div style={{ marginTop: 16 }}>Price Type:</div>
      <Row justify="space-between" style={{ alignItems: "center" }}>
        <Col>
          <Radio.Group style={{ marginBottom: 16 }} onChange={handleChangePriceType} value={priceType}>
            <Radio value={EntityType.Dealer}>
              <strong>Dealer</strong>
            </Radio>
            <Radio value={EntityType.Transporter}>
              <strong>Transporter</strong>
            </Radio>
          </Radio.Group>
        </Col>
        <Col>
          <Button type="primary" onClick={handleClickReset}>
            Reset
          </Button>
        </Col>
      </Row>

      <div style={{ marginTop: 16 }}>Price Adjust Type:</div>
      <Row justify="space-between" style={{ alignItems: "center" }}>
        <Col>
          <Radio.Group
            style={{ marginBottom: 16 }}
            value={priceAdjustmentType}
            onChange={handleChangePriceAdjustmentType}
          >
            <Radio value={PriceAdjustType.ToDollarAmmount}>
              <strong>To Dollar Amount</strong>
            </Radio>
            <Radio value={PriceAdjustType.ByDollarAmmount}>
              <strong>By Dollar Amount</strong>
            </Radio>
            <Radio value={PriceAdjustType.ByPercentage}>
              <strong>By Percentage</strong>
            </Radio>
          </Radio.Group>
        </Col>

        <Col>
          <Radio.Group
            style={{ marginBottom: 16 }}
            onChange={handleChangePriceAdjustmentDirection}
            value={priceAdjustmentDirection}
            buttonStyle="solid"
            disabled={priceAdjustmentType === PriceAdjustType.ToDollarAmmount}
          >
            <Radio.Button value={PriceAdjustmentDirection.Increase}>
              <strong>Increase</strong>
              <PlusOutlined style={{ marginLeft: 8 }} />
            </Radio.Button>
            <Radio.Button value={PriceAdjustmentDirection.Decrease}>
              <strong>Decrease</strong>
              <MinusOutlined style={{ marginLeft: 8 }} />
            </Radio.Button>
          </Radio.Group>
        </Col>
      </Row>

      <div style={{ marginTop: 16 }}>Price Adjust Amount:</div>
      <Row justify="space-between">
        <Col style={{ flexGrow: 0.9 }}>
          <Slider
            min={0}
            max={maxAdjustmentAmount}
            onChange={newPrice => setPriceAdjustmentAmount(newPrice)}
            value={priceAdjustmentAmount}
            marks={priceSliderMarks}
            step={5}
            tooltipVisible={false}
            style={{ width: "100%" }}
          />
        </Col>
        <Col>
          <InputNumber
            min={0}
            style={{ width: 100 }}
            formatter={value => {
              const str = priceAdjustmentType < PriceAdjustType.ByPercentage ? `$ ${value}` : `${value}%`;
              return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }}
            parser={value => value.replace(/[^\d]/g, "")}
            value={priceAdjustmentAmount}
            step={5}
            onChange={newPrice => setPriceAdjustmentAmount(newPrice)}
          />
        </Col>
      </Row>
    </>
  );
};

export default PriceAdjustmentControls;
